export default __webpack_public_path__ + "static/media/20200730-ethereum-chart.415097bf.png";